import type { NextPage, GetServerSideProps } from 'next'
import { PageTemplate } from '../components/PageTemplate'
import { Layout } from '../components/Layout'
import { PageContent, PageConfig } from '../types/page_component_types'
import { getPagePropsBySlug } from '../utils/get_page_props_by_slug'
import { extractFaqItems } from '../utils/extractFaqItems'

const CurrentPage: NextPage<{
  pageContent?: PageContent
  pageConfig: PageConfig
  availableLocales?: string[]
}> = ({ pageContent, pageConfig, availableLocales }) => {
  return (
    <Layout
      config={pageConfig}
      meta={pageContent?.meta}
      slug={pageContent?.slug}
      availableLocales={availableLocales}
      faqItems={extractFaqItems(pageContent?.content)}
    >
      <PageTemplate content={pageContent?.content} />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  // Note: the old `slug === 'cookies'` guard was redundant — `pages/cookies.tsx`
  // is a static route that Next.js resolves before this dynamic `[slug].tsx`.
  return await getPagePropsBySlug(context, '')
}

export default CurrentPage
